module.exports = __webpack_public_path__ + "img/icon_login.55241ce6.svg";